/**
 * A recusa do portão do laudo eletrônico em linguagem acionável para o dono do caso (E74.F3).
 *
 * Saiu da página na E180.F2 (GUS-254): com o motivo `regua_anterior` — a CCB verificada com a
 * régua anterior, que a conclusão do perito não segura mais — a página passou do teto de linhas.
 * Cada motivo nomeia as CCBs quando o servidor as manda.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { LaudoEletronicoError, LaudoEletronicoMotivo } from '@/lib/laudo_eletronico';

const t = ptBR.laudoEletronico;

const COM_AS_CCBS: Partial<Record<LaudoEletronicoMotivo, string>> = {
  exame_pendente: t.naoProntoPendentes,
  verificacao_desalinhada: t.naoProntoDesalinhadas,
  regua_anterior: t.naoProntoReguaAnterior,
};

const SEM_AS_CCBS: Partial<Record<LaudoEletronicoMotivo, string>> = {
  revisao_pendente: t.naoProntoRevisao,
  sem_ccb: t.naoProntoSemCcb,
  leitura_em_conferencia: t.naoProntoLeitura,
};

export function textoDaRecusa(erro: LaudoEletronicoError): string {
  if (erro.reason !== 'not_ready') {
    return erro.reason === 'render_failed' ? t.errorRender : t.errorGeneric;
  }
  const motivo = erro.motivo;
  if (motivo === null) return t.naoPronto;
  const comAsCcbs = COM_AS_CCBS[motivo];
  if (comAsCcbs !== undefined && erro.pendentes.length > 0) {
    return `${t.naoPronto} ${comAsCcbs.replace('{ccbs}', erro.pendentes.join(', '))}`;
  }
  const semAsCcbs = SEM_AS_CCBS[motivo];
  return semAsCcbs === undefined ? t.naoPronto : `${t.naoPronto} ${semAsCcbs}`;
}
